<div *ngFor="let link of socialLinks" class="social-outline">
  <img [alt]="link.label" [src]="link.iconPath" (click)="goTo(link.url)">
</div>
